

module.exports = __webpack_require__.stylable.create(
    "Ellipsis4018248282",
    {"classes":{"root":"Ellipsis4018248282__root","text":"Ellipsis4018248282__text","tooltip":"Ellipsis4018248282__tooltip"},"vars":{"maxLines":"--Ellipsis4018248282-maxLines"},"stVars":{},"keyframes":{}},
    "",
    4,
    "Ellipsis4018248282",
    null
);
